import React from "react";
import { useEditTcpAllowanceExpenseRateMutation } from "./queries.generated";
import { MutationForm } from "~/components/forms/MutationForm";
import { FormProps, FormData } from "./types";
import { TcpAllowanceExpenseRate, ValidationResponse } from "~/gql/types";
import { parseNum } from ".";

export const EditTcpAllowanceExpenseRate: React.FC<
  FormProps & { original: TcpAllowanceExpenseRate }
> = (props) => {
  const { setLoading, original, rateSheet, onSuccess, children } = props;

  const [rawTcpMutation] = useEditTcpAllowanceExpenseRateMutation();

  const initialValues = {
    name: original.name,
    invoiceLabel: original.invoiceLabel,
    expenseAccount: original.expenseAccount,
    glAccount: original.glAccount,
    reimbursableAmount: original.reimbursableAmount.toString(),
  };

  const handleSubmit = async (values: FormData) => {
    const variables = {
      oldName: original?.name!,
      name: values?.name!,
      rateSheetName: rateSheet.name,
      invoiceLabel: values?.invoiceLabel || null,
      expenseAccount: values?.expenseAccount || null,
      glAccount: values?.glAccount || null,
      reimbursableAmount: parseNum(values?.reimbursableAmount)!,
    };

    const result = await rawTcpMutation({ variables });

    return result?.data?.expenseRates
      ?.editTcpAllowanceRate as ValidationResponse;
  };

  return (
    <MutationForm
      setLoading={setLoading}
      initialValues={initialValues}
      runMutation={handleSubmit}
      onSuccess={onSuccess}
      allowPristineSubmit
    >
      {children}
    </MutationForm>
  );
};
